module.exports = __webpack_public_path__ + "img/io.a59394ad.svg";